import { EventEmitter } from '@angular/core';
import { ButtonsActionsTableComponent, CheckTableComponent } from '@app/shared';

export class MasterAccessControlConfigService {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor() {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'Actualmente no hay acceso a otras maestras',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        nombre_maestra: {
          editable: false,
          addable: false,
          title: 'Maestra',
          filter: {
            inputClass: 'form-control',
          },
        },
        agregar: {
          title: 'Agregar',
          type: 'custom',
          renderComponent: CheckTableComponent,
          filter: {
            inputClass: 'form-control',
            type: 'checkbox',
            config: {
              true: 'true',
              false: 'false',
              resetText: 'Todo',
            },
          },
        },
        modificar: {
          title: 'Modificar',
          type: 'custom',
          renderComponent: CheckTableComponent,
          filter: {
            inputClass: 'form-control',
            type: 'checkbox',
            config: {
              true: 'true',
              false: 'false',
              resetText: 'Todo',
            },
          },
        },
        eliminar: {
          title: 'Eliminar',
          type: 'custom',
          renderComponent: CheckTableComponent,
          filter: {
            inputClass: 'form-control',
            type: 'checkbox',
            config: {
              true: 'true',
              false: 'false',
              resetText: 'Todo',
            },
          },
        },
        index: {
          title: 'Acciones',
          filter: false,
          type: 'custom',
          renderComponent: ButtonsActionsTableComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/master-access-control/shared/master-access-control.config.service.ts